export default __webpack_public_path__ + "static/media/MonochromeWorkshop-768x255.6b43c238.png";